import { useEffect, useState } from 'react';
import { getOptions } from "@/api";

export default function FacebookPixel() {

    const [pixelId, setPixelId] = useState("");

    useEffect(() => {
        const fetchPixelId = async () => {
            try {
                const options = await getOptions();
                setPixelId(options?.facebook_pixel || "");
            } catch (error) {
                console.error("Failed to fetch Facebook Pixel options:", error);
            }
        };
        fetchPixelId();
    }, []);

    useEffect(() => {
        if (!pixelId) {
            return;
        }

        // Initialize Facebook Pixel
        if (typeof window !== 'undefined') {
            // fbq function stub
            (function(f,b,e,v,n,t,s) {
                if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)
            })(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');

            window.fbq('init', pixelId);
            window.fbq('track', 'PageView');
        }
    }, [pixelId]);

    useEffect(() => {
        // Track page views on route change
        if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('track', 'PageView');
        }
    }, []);

    return null;
}
